'use strict';
import * as $j_app$002etulz$002etuplez$002e$002dComposition from "./app.tulz.tuplez.-Composition.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_tulz_tuplez_Composition$$anon$277() {
}
export { $c_Lapp_tulz_tuplez_Composition$$anon$277 as $c_Lapp_tulz_tuplez_Composition$$anon$277 };
$c_Lapp_tulz_tuplez_Composition$$anon$277.prototype = new $j_app$002etulz$002etuplez$002e$002dComposition.$h_Lapp_tulz_tuplez_Composition();
$c_Lapp_tulz_tuplez_Composition$$anon$277.prototype.constructor = $c_Lapp_tulz_tuplez_Composition$$anon$277;
/** @constructor */
function $h_Lapp_tulz_tuplez_Composition$$anon$277() {
}
export { $h_Lapp_tulz_tuplez_Composition$$anon$277 as $h_Lapp_tulz_tuplez_Composition$$anon$277 };
$h_Lapp_tulz_tuplez_Composition$$anon$277.prototype = $c_Lapp_tulz_tuplez_Composition$$anon$277.prototype;
$c_Lapp_tulz_tuplez_Composition$$anon$277.prototype.compose__O__O__O = (function(a, b) {
  return (void 0);
});
$c_Lapp_tulz_tuplez_Composition$$anon$277.prototype.decompose__O__T2 = (function(c) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), (void 0), (void 0));
});
var $d_Lapp_tulz_tuplez_Composition$$anon$277 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_tulz_tuplez_Composition$$anon$277, "app.tulz.tuplez.Composition$$anon$277", ({
  Lapp_tulz_tuplez_Composition$$anon$277: 1,
  Lapp_tulz_tuplez_Composition: 1
}));
export { $d_Lapp_tulz_tuplez_Composition$$anon$277 as $d_Lapp_tulz_tuplez_Composition$$anon$277 };
//# sourceMappingURL=app.tulz.tuplez.-Composition$$anon$277.js.map
